import { useState } from 'react';
import { buscarUcDaFatura } from '../lib/buscarUcDaFatura';
import { resolverLinkBoleto } from '../../../../src/lib/linkBoleto';
import { useToast } from '../../../../src/contexts/ToastContext';
import type { FaturaPainel } from '../types';
import type { UnidadeConsumidora } from '../../../../types';

/**
 * As ações de cada linha da lista de boletos dos KPIs — abrir a UC e abrir o PDF.
 * Compartilhado entre o Painel Financeiro e o Painel Executivo geral, que abrem
 * a mesma lista a partir dos mesmos cards.
 */
export function useAcoesBoleto() {
  const { addToast } = useToast();
  const [ucAberta, setUcAberta] = useState<UnidadeConsumidora | null>(null);
  const [abrindoUcId, setAbrindoUcId] = useState<string | null>(null);
  const [abrindoBoletoId, setAbrindoBoletoId] = useState<string | null>(null);

  const abrirUc = async (f: FaturaPainel) => {
    setAbrindoUcId(f.id);
    try {
      const uc = await buscarUcDaFatura(f.uc_codigo);
      if (uc) setUcAberta(uc);
      else addToast(`A UC ${f.uc_codigo} não tem cadastro. Procure a fatura em Financeiro › Faturas e Cobranças.`, 'info', 6000);
    } catch (e: any) {
      console.error('Erro ao buscar a UC da fatura:', e);
      addToast(e?.message || 'Não foi possível abrir a UC.', 'error');
    } finally {
      setAbrindoUcId(null);
    }
  };

  const abrirBoleto = async (f: FaturaPainel) => {
    // A aba abre ANTES do await: aberta depois, o navegador trata como pop-up e bloqueia.
    const aba = window.open('', '_blank');
    setAbrindoBoletoId(f.id);
    try {
      const url = await resolverLinkBoleto(f);
      if (url && aba) aba.location.href = url;
      else {
        aba?.close();
        addToast(url ? 'O navegador bloqueou a nova aba do boleto.' : 'Esta fatura não tem PDF de boleto disponível.', 'info');
      }
    } catch (e: any) {
      aba?.close();
      addToast(e?.message || 'Não foi possível abrir o boleto.', 'error');
    } finally {
      setAbrindoBoletoId(null);
    }
  };

  return { ucAberta, setUcAberta, abrindoUcId, abrindoBoletoId, abrirUc, abrirBoleto };
}
